import { create } from "zustand"
export interface IRole {
  id: number
  value: string
  name: string
}

interface RoleState {
  role: IRole | null
  setRole: (role: IRole) => void
}

export const useRoleStore = create<RoleState>(set => ({
  role: null,
  setRole: role => set({ role })
}))
